export enum ProbabilityShareType {
	EVENT = 'EVENT',
	MATCH_RESULTS = 'MATCH_RESULTS',
	PROFILE = 'PROFILE',
	RANK = 'RANK',
	LOCKED_IN = 'LOCKED_IN',
}
